import { TableEmptyState } from '@practium/ui';
import type { BindingUser } from '../../../types';
import { applyPhoneMask } from '../../../utils/masks';
import styles from '../PeopleTable.module.css';

interface BindingFarmersTableProps {
	farmers: BindingUser[];
	onRowClick?: (id: string) => void;
	onEnterProfile?: (id: string) => void;
}

export const BindingFarmersTable = ({
	farmers,
	onRowClick,
	onEnterProfile,
}: BindingFarmersTableProps) => {
	if (farmers.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum agricultor encontrado"
				subtitle="Adicione um agricultor para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Sobrenome</th>
						<th>Telefone</th>
						<th>E-mail</th>
						<th>Status</th>
						{onEnterProfile && <th></th>}
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{farmers.map((item) => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.surName}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.phoneNumber ? applyPhoneMask(item.phoneNumber) : '—'}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.email}</span>
							</td>
							<td>
								<span
									className={`${styles.statusBadge} ${
										item.status ? styles.statusActive : styles.statusInactive
									}`}
								>
									{item.status ? 'Ativo' : 'Inativo'}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
